export default __webpack_public_path__ + "static/media/Medal.b1eb661b.svg";